<top-banner variant="title" [title]="selectedWorker ? selectedWorker.firstName + ' ' + selectedWorker.lastName : ''"></top-banner>

<div class="main-content">
  <div class="card animated fadeIn">
    <div class="row">
      <div class="col-md-2 cardtabs-wrapper">
        <app-card-tabs [tabitems]="tabitems" [backLink]="backLink ? { path: backLink, title: 'Back' } : null"></app-card-tabs>
      </div>

      <div class="col-md-10">
        <div class="card-body">
          <card-section-header title="Sites" icon="fas fa-list" [showButton]="false"></card-section-header>

          <ng-container *ngIf="isAdmin">
            <div class="mb-4">
              <div *ngIf="!siteOwners.length" style="text-align: center;">
                <p-progressSpinner></p-progressSpinner>
              </div>

              <ng-container *ngIf="siteOwners.length">
                <label>Select a site owner</label>
                <p-dropdown
                class="form-control"
                [(ngModel)]="selectedSiteOwner"
                [ngModelOptions]="{standalone: true}"
                (ngModelChange)="onSelectedSiteOwnerChange($event)"
                [options]="siteOwners"
                placeholder="Select a site owner..."
                [style]="{'width':'100%'}"
                optionLabel="label"
                filter="true"
                ></p-dropdown>
              </ng-container>
            </div>
          </ng-container>

          <p-table [value]="filteredSites" [autoLayout]="true">
            <ng-template pTemplate="header">
              <tr>
                <th (click)="toggleSelectAll()"><button type="button" class="btn btn-secondary btn-sm btn-link"><i class="fas fa-check-double"></i></button></th>
                <th>Site</th>
                <th *ngIf="uniqueSiteOwnerCount > 1">Site Owner</th>
                <th class="table-cell-centered">Added to site</th>
                <th>Asset Categories</th>
                <th class="table-cell-centered">Guests Permitted</th>
                <th class="table-cell-centered">Site Session Permitted</th>
                <th>Induction</th>
                <th></th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-site let-rowIndex="rowIndex">
              <ng-container *ngIf="rowGroupMetadata[site.siteType.id].index === rowIndex">
                <tr class="ui-widget-header">
                  <td colspan="8">
                    <span style="font-weight: bold">{{ site.siteType.name }}</span>
                    <button type="button" class="btn btn-secondary btn-sm btn-link" (click)="toggleSelectAllBySiteType(site.siteType.id)"><i class="fas fa-check-double"></i></button>
                  </td>
                </tr>
              </ng-container>
              <tr>
                <td class="table-cell-centered" (click)="checkboxChange(!tickedBoxes.includes(site.id), site.id)">
                  <div class="">
                    <input type="checkbox" [checked]="tickedBoxes.includes(site.id)" />
                  </div>
                </td>
                <td>
                  <a [routerLink]="['/', routeRole, 'sites', site.id, 'workers']">
                    {{ site.name }}
                  </a>
                </td>
                <td *ngIf="uniqueSiteOwnerCount > 1">
                  {{ site.siteOwner?.name }}
                </td>
                <td class="text-center">
                  <i *ngIf="site.onSite && site.siteDelegate" class="fas fa-star warning"
                      [ngbTooltip]="'Site Delegate'" placement="bottom"></i>
                  <i *ngIf="site.onSite && !site.siteDelegate" class="fas fa-check-circle success"></i>
                  <i *ngIf="!site.onSite" class="fas fa-times-circle danger"></i>
                </td>
                <ng-container *ngIf="!site.onSite">
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                </ng-container>
                <ng-container *ngIf="site.onSite">
                  <td>
                    <span *ngFor="let item of site.assetCategories" class="badge badge-pill badge-success" [ngStyle]="{ 'background-color': item.color }">{{ item.name }}<br /></span>
                  </td>
                  <td class="text-center">
                    <i *ngIf="site.guestsPermitted" class="fas fa-check-circle success"></i>
                    <i *ngIf="!site.guestsPermitted" class="fas fa-times-circle danger"></i>
                  </td>
                  <td class="text-center">
                    <i *ngIf="site.managementDuty" class="fas fa-check-circle success"></i>
                    <i *ngIf="!site.managementDuty" class="fas fa-times-circle danger"></i>
                  </td>
                  <td class="table-cell-centered">
                    <ng-container *ngIf="site.siteInductionCourse && site.inductionForSite && site.inductionForSite.courseProgress === TrainingCourseStateType.Completed">
                      <span class="badge badge-pill badge-success">Valid until: {{ site.inductionForSite.expiryDate | date : 'mediumDate' }}</span>
                    </ng-container>
                    <ng-container *ngIf="site.siteInductionCourse && site.inductionForSite && site.inductionForSite.courseProgress === TrainingCourseStateType.Expired">
                      <span class="badge badge-pill badge-warning">Expired on: {{ site.inductionForSite.expiryDate | date : 'mediumDate' }}</span>
                      <ng-template *ngTemplateOutlet="reminderButton; context: { site: site }"></ng-template>
                    </ng-container>
                    <ng-container *ngIf="site.siteInductionCourse && !site.inductionForSite">
                      <span class="badge badge-pill badge-danger">Not Passed</span>
                      <ng-template *ngTemplateOutlet="reminderButton; context: { site: site }"></ng-template>
                    </ng-container>
                    <ng-container *ngIf="!site.siteInductionCourse">
                      <span class="badge badge-pill badge-default">None required</span>
                    </ng-container>

                    <ng-template #reminderButton let-context="site">
                      <div>
                        <button
                          type="button"
                          class="btn btn-primary btn-link"
                          [disabled]="context.isSendingInductionReminder || context.inductionReminderSent"
                          (click)="$event.stopPropagation(); resendInductionReminder(context)"
                        >
                          <ng-container *ngIf="context.isSendingInductionReminder">
                            <span class="spinner-border spinner-border-sm mr-1" role="status" aria-hidden="true"></span>
                            Sending...
                          </ng-container>
                          <ng-container *ngIf="!context.isSendingInductionReminder">
                            <span *ngIf="!context.inductionReminderSent">Resend reminder</span>
                            <span *ngIf="context.inductionReminderSent">Reminder sent</span>
                          </ng-container>
                        </button>
                      </div>
                    </ng-template>
                  </td>
                </ng-container>
                <td>
                  <button [disabled]="tickedBoxes.length && !tickedBoxes.includes(site.id)" class="btn btn-sm btn-simple" (click)="onLeftMouseClick($event, contextMenu, site)"><i class="fas fa-ellipsis-v"></i></button>
                  <p-contextMenu #contextMenu [model]="contextMenuItems" [appendTo]="'body'" ></p-contextMenu>
                </td>
              </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage" let-columns>
              <tr>
                <td [attr.colspan]="8">No sites found</td>
              </tr>
            </ng-template>
          </p-table>
        </div>
      </div>

    </div>
  </div>
</div>
